var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth-wrapper auth-v2"
  }, [_c('b-row', {
    staticClass: "auth-inner m-0"
  }, [_c('b-link', {
    staticClass: "brand-logo d-flex align-items-center"
  }), _c('b-col', {
    staticClass: "d-none d-lg-flex p-0 auth-hero-wrap",
    attrs: {
      "lg": "8"
    }
  }, [_c('section', {
    staticClass: "auth-hero-content w-100 h-100 d-flex flex-column justify-content-between"
  }, [_c('div', {
    staticClass: "auth-hero-top d-flex align-items-center"
  }, [_c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "56px"
    },
    attrs: {
      "src": "/assets/logo-96.png",
      "alt": "Logo"
    }
  }), _c('div', [_c('h3', {
    staticClass: "mb-0 text-white"
  }, [_vm._v("PT. BIMA")]), _c('small', {
    staticClass: "text-white-70"
  }, [_vm._v("ERP System")])])]), _c('div', {
    staticClass: "auth-hero-main"
  }, [_c('h1', {
    staticClass: "auth-hero-title"
  }, [_vm._v(" Kelola operasional dengan cepat dan terintegrasi. ")]), _c('p', {
    staticClass: "auth-hero-subtitle"
  }, [_vm._v(" Pantau stok, penerimaan, distribusi, dan laporan dalam satu dashboard terpadu ERP BIMA. ")]), _c('ul', {
    staticClass: "auth-hero-points mb-0"
  }, [_c('li', [_vm._v("Monitoring stok realtime lintas gudang.")]), _c('li', [_vm._v("Alur penerimaan dan penempatan lebih tertata.")]), _c('li', [_vm._v("Data transaksi siap audit dan mudah ditelusuri.")])])]), _c('small', {
    staticClass: "text-white-70"
  }, [_vm._v(" ERP BIMA — Mendukung keputusan operasional harian. ")])])]), _c('b-col', {
    staticClass: "d-flex align-items-center auth-bg px-2 p-lg-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-col', {
    staticClass: "px-xl-2 mx-auto",
    attrs: {
      "sm": "8",
      "md": "6",
      "lg": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "mb-1 font-weight-bold mt-3",
    attrs: {
      "title-tag": "h2"
    }
  }, [_vm._v(" Selamat Datang di ERP System ")]), _c('b-card-text', {
    staticClass: "mb-2"
  }, [_vm._v(" Silakan Login ")]), _c('validation-observer', {
    ref: "loginForm",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var invalid = _ref.invalid;
        return [_c('b-form', {
          staticClass: "auth-login-form mt-2",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.login($event);
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Email",
            "label-for": "login-email"
          }
        }, [_c('validation-provider', {
          attrs: {
            "name": "Email",
            "vid": "email",
            "rules": "required|email"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var errors = _ref2.errors;
              return [_c('b-form-input', {
                attrs: {
                  "id": "login-email",
                  "state": errors.length > 0 ? false : null,
                  "name": "login-email",
                  "placeholder": "email@example.com"
                },
                model: {
                  value: _vm.userEmail,
                  callback: function callback($$v) {
                    _vm.userEmail = $$v;
                  },
                  expression: "userEmail"
                }
              }), _c('small', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('b-form-group', [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('label', {
          attrs: {
            "for": "login-password"
          }
        }, [_vm._v("Password")])]), _c('validation-provider', {
          attrs: {
            "name": "Password",
            "vid": "password",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var errors = _ref3.errors;
              return [_c('b-input-group', {
                staticClass: "input-group-merge",
                class: errors.length > 0 ? 'is-invalid' : null
              }, [_c('b-form-input', {
                staticClass: "form-control-merge",
                attrs: {
                  "id": "login-password",
                  "state": errors.length > 0 ? false : null,
                  "type": _vm.passwordFieldType,
                  "name": "login-password",
                  "placeholder": "Password"
                },
                model: {
                  value: _vm.password,
                  callback: function callback($$v) {
                    _vm.password = $$v;
                  },
                  expression: "password"
                }
              }), _c('b-input-group-append', {
                attrs: {
                  "is-text": ""
                }
              }, [_c('feather-icon', {
                staticClass: "cursor-pointer",
                attrs: {
                  "icon": _vm.passwordToggleIcon
                },
                on: {
                  "click": _vm.togglePasswordVisibility
                }
              })], 1)], 1), _c('small', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('b-button', {
          staticClass: "mb-2",
          attrs: {
            "type": "submit",
            "variant": "primary",
            "block": "",
            "disabled": invalid
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.login($event);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.loginLabel) + " ")])], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }